import {
  AncillaryInt,
  BagAncillarieInt,
  ResidenceInfo,
  SeatPassanger,
  SeatBenefit,
} from '@interfaces/*';
import {
  BagsWeightCode,
  ESTATUS_CHECKIN,
  FARES_FAMILY,
  GROUP_CODE,
  PAX_TYPE,
  PAX_TYPE_SHORT,
  StatusBag,
  TypeBagsWeight,
  SeatPassangerEstatus,
} from '@app/enums';
import { InternationFlow } from '../internationFlow.model';
import {
  PassengerAWSInt,
  PassengerInfoInt,
  ContactTracingInt,
  RemarksInt,
} from '@app/interfaces/reservation-aws.interface';
import { PassportRQ } from './request/requestMicro.model';
import {
  FreeTextInfoList,
  MissingCheckinRequiredFields,
  PassengerIds,
  RequiredInfoList,
} from '@models/micro/response/viewDocuments.model';
import { ssrBloquers, ssrsChairAssistant } from '@utils/constants/ssrBloquers';
import { Reservation } from '@app/models/micro/reservation.model';

import { BagsPassangerInt } from '@app/interfaces/micro/bags.interface';
import { getUniqueId } from '@app/utils';
import { RespBenefits } from './response/respBenefits.model';
import { MappedCorporateInt } from '@app/interfaces/micro/loyalty.interface';
import { CODES_OVERWEIGHT } from '@app/utils/constants/generals';
import { isInbursaCobrand } from '@app/utils/constants/cobrand';
export class Passenger {
  public ancillaries: any[];
  public cabinClass: string;
  public corporate: MappedCorporateInt;
  public checkinSelected: boolean;
  public checkinStatus: boolean = false;
  public checkinStatusDocuments: boolean = false;
  public checkinStatusBySegment;
  public countryOfResidence: string;
  public dateOfBirth: string;
  public destinationAddress: string;
  public displayName: string;
  public email: string;
  public emergencyContact: boolean = false;
  public etaAlreadySent;
  public firstName: string;
  public frequentFlyerNumber: string;
  public frequentFlyerProgram: string;
  public frequentFlyerProgramDisplayName: string;
  public gender: string;
  public hasInfant: boolean;
  public id: string;
  public internationFlow: InternationFlow;
  public isEligibleToCheckin: boolean = false;
  public isMultipleTickets: boolean;
  public isWheelChair: boolean;
  public isSkyPriority: boolean = false;
  public lastName: string;
  public nameRefNumber: string;
  public onwardTravelDate;
  public passengerInfo: PassengerInfoInt;
  public passport: PassportRQ;
  public paidAncillaries: AncillaryInt[];
  public paxType: PAX_TYPE;
  public phones: any;
  public priorityCode: string;
  public redressNumber: string;
  public residenceInfo: ResidenceInfo;
  public returningDateAlreadySent;
  public showAdditionalInfo: boolean;
  public ssrs: any;
  public ticketInfo: any;
  public timaticProvided;
  public upgradeCode: string;
  public isSelectedToCheckin: boolean;
  public timaticRQ: any;
  public contactTracing: ContactTracingInt;
  public requiredContactTracing: boolean = false;
  frequentFlyerName = null;
  public ffTierLevel = '';
  public ancillariesFfTier = '';
  public missingCheckinRequiredFields: MissingCheckinRequiredFields[];
  public passengerIds: PassengerIds[];
  public requiredInfoList: RequiredInfoList[];
  public freeTextInfoList: FreeTextInfoList[];
  public passengerId: string;
  public applicationVisaContry: string = null;
  public ineligibleReasons: any[];
  public onPriorityCodeListOVS: boolean;
  public candidateForUpgradeList: boolean;
  public onUpgradeList: boolean;
  public travelDocument: any[];
  public pectab: string;
  public passengerInfant: string;
  public infantInfo: Passenger;
  public coupons: any[];
  public isStandBy: boolean = false;
  public updateGender: boolean = false;
  public sendContactability: boolean = false;
  public isOkToBoard: boolean = false;
  public isSelectForBagagge: boolean = false;
  public passengerIdSkyteam: string;
  public sourceMissing: string;
  public seatCode: string;
  public zone: any;
  public googleWalletPass: any;
  public benefits: RespBenefits;
  public typeTier: 'tier' | 'cobrand' | 'corporate' | 'f&f' | null = null;
  public typeCobrand: 'tier' | 'cobrand' | 'corporate' | 'f&f' | null = null;
  public typeCorporate: 'tier' | 'cobrand' | 'corporate' | 'f&f' | null = null;
  public typeff: 'tier' | 'cobrand' | 'corporate' | 'f&f' | null = null;
  public switchRedeem: boolean = false;
  public blockLimitPassengers: boolean;
  public shortBaggageDrop: boolean = false;
  public bagStack: Array<BagsPassangerInt> = [];
  public bagStackCarryon: Array<BagsPassangerInt> = [];
  public bagOfferStack = [];
  public documentedBagsCount: number = 0;
  public bagOfferCarryOnStack = [];
  public sprinklr: boolean = false;
  public seats: Array<SeatPassanger> = [];
  public seatsNew: Array<SeatPassanger> = [];
  public seatBenefit: SeatBenefit;
  public prePaidSeat: boolean;
  public totalseatscurrency: number;

  mapBoardingPass = [];
  travelDocFormat: string[];

  constructor(passenger?: PassengerAWSInt, reservation?: Reservation) {
    if (passenger) {
      const paxType = {
        [PAX_TYPE_SHORT.ADULT]: PAX_TYPE.ADULT,
        [PAX_TYPE_SHORT.CHILD]: PAX_TYPE.CHILD,
        [PAX_TYPE_SHORT.INFANT]: PAX_TYPE.INFANT,
      };
      const originalType = passenger.passengerInfo?.originalType?.split('-');
      this.ancillaries = this.setAncillaries(passenger.ancillaries);
      this.checkinSelected = false;
      this.checkinStatus = !!passenger?.ticketInfo?.coupons.find((c) => c.couponStatus == 'CKIN');
      this.countryOfResidence = passenger.passengerInfo.countryResidence;
      this.dateOfBirth = passenger.passengerInfo.dateOfBirth;
      this.destinationAddress = passenger.passengerInfo.destinationAddress;
      this.displayName = `${passenger.passengerDetails.displayFirstName} ${passenger.passengerDetails.displayLastName}`;
      this.email = passenger.passengerInfo.emailId;
      this.emergencyContact = passenger.passengerInfo.emergencyContact;
      this.firstName = passenger.passengerDetails.firstName;
      this.frequentFlyerNumber = passenger.passengerInfo.ffNumber;
      this.frequentFlyerProgram = passenger.passengerInfo.ffProgram;
      this.frequentFlyerName = passenger.passengerInfo.ffName;
      this.gender = passenger.passengerInfo.gender;
      this.id = passenger.id;
      this.isMultipleTickets = passenger.isMultipleTickets;
      this.isWheelChair = passenger.isWheelChair;
      this.isSkyPriority = passenger.isSkyPriority;
      this.lastName = passenger.passengerDetails.lastName;
      this.nameRefNumber = passenger.passengerNameNumber;
      this.passengerInfo = passenger.passengerInfo;
      this.ffTierLevel = (this.passengerInfo?.ffTierLevel || '').trim();
      this.passport = new PassportRQ(passenger?.passport);
      this.paxType = passenger.passengerInfo.type
        ? paxType[passenger.passengerInfo.type]
        : paxType[originalType[0]];
      this.phones = passenger.passengerInfo.phones;
      this.priorityCode = passenger.priorityCode;
      this.redressNumber = passenger.passengerInfo.redressNumber;
      this.showAdditionalInfo = true;
      this.ssrs = passenger.ssrs;
      this.ticketInfo = passenger.ticketInfo;
      this.upgradeCode = passenger.upgradeCode;
      this.onPriorityCodeListOVS = false;
      this.passengerId = passenger.passengerId;
      this.passengerIds = passenger?.passengerIds;
      this.travelDocument = [];
      this.pectab = '';
      this.coupons = passenger?.ticketInfo?.coupons;
      this.passengerInfant = passenger.passengerInfant;
      this.hasInfant = this.paxType == PAX_TYPE.INFANT;
      this.isOkToBoard = false;
      this.seats = this.mapSeatPassenger(passenger?.seats);
      this.seatsNew = [];
      this.sprinklr = passenger?.sprinklr;
      // SSR Remarks
      this.hasInfant = this.contentInfant();
      this.changeStatus();

      if (this.paxType == PAX_TYPE.ADULT || this.paxType == PAX_TYPE.CHILD) {
        this.getStackBags(reservation);
        // this.getSeatBenifit(passenger.benefit);
        // this.getSeatPassanger(passenger.seats)
        /*this.getBookingClasse(passenger.bookingClasses);
        this.internationFlow = new InternationFlow(passenger.missingCheckinRequiredFields); */
        // this.hasInfant = this.hasInfant ? true : false;
        // this.ffTierLevel = this.getFFTierLevel();
      }
    }
  }

  get estatusCheckin() {
    let estatusCheckin: ESTATUS_CHECKIN;

    if (this.mustGoToCounterByMissingPassengerIds) {
      estatusCheckin = ESTATUS_CHECKIN.NO_ELEGIBLE_TO_CHECKIN;
    } else {
      if (this.blockLimitPassengers) {
        estatusCheckin = ESTATUS_CHECKIN.MAX_PASSENGERS;
      } else {
        if (this.isEligibleToCheckin && !this.hasBlockSSR && !this.notHasVCR && !this.sprinklr) {
          if (this.isOkToBoard && this.hasVerifyDocument) {
            estatusCheckin = ESTATUS_CHECKIN.NO_ELEGIBLE_TO_CHECKIN;
          } else {
            if (this.hasVerifyDocument && this.checkinStatusDocuments) {
              estatusCheckin = ESTATUS_CHECKIN.NO_ELEGIBLE_TO_CHECKIN;
            } else {
              estatusCheckin = this.validStatusCheckInAndDoc();
            }
          }
        } else {
          if (
            this.onPriorityCodeListOVS &&
            !this.hasBlockSSR &&
            !this.notHasVCR &&
            !this.sprinklr
          ) {
            estatusCheckin = this.validStatusCheckInAndDoc();
          } else {
            estatusCheckin = ESTATUS_CHECKIN.NO_ELEGIBLE_TO_CHECKIN;
          }
        }
      }
    }

    return estatusCheckin;
  }

  isCompleteInformationContact() {
    let emailValid = true;
    if (this.paxType === PAX_TYPE.ADULT) {
      emailValid = this.passengerInfo?.emails?.length > 0;
    }
    return (
      emailValid &&
      this.passengerInfo?.phones?.length > 0 &&
      this.passengerInfo.dateOfBirth &&
      this.passengerInfo.gender
    );
  }

  isSkyCleared(): boolean {
    return !!this.ssrs.find((el) => el.code === 'ADOC');
  }

  isIsDeclaredCOVIDTest(): boolean {
    return !!this.ssrs.find((mark) => mark.code === 'TAOK');
  }

  changeStatusFF() {
    return this.passengerInfo.ffNumber === '' && this.passengerInfo.ffProgram === ''
      ? ESTATUS_CHECKIN.NOT_DOCUMENTS
      : ESTATUS_CHECKIN.READY_FOR_CHECKIN;
  }

  hasDobleConfort(): boolean {
    return !!this.ssrs.find((mark) => mark.code === 'NFST');
  }

  get genderDoocuments() {
    return this.gender == 'Female' ? 'F' : 'M';
  }

  validStatusCheckInAndDoc() {
    if (!this.checkinStatus && !this.checkinStatusDocuments && !this.sprinklr) {
      return ESTATUS_CHECKIN.NOT_DOCUMENTS;
    } else {
      return this.checkinStatus ? ESTATUS_CHECKIN.HAS_CHEKIN : ESTATUS_CHECKIN.READY_FOR_CHECKIN;
    }
  }

  changeStatus(reservation?: Reservation) {
    const doctos: MissingCheckinRequiredFields[] = this.missingCheckinRequiredFields ?? [];

    // Filtra solo los documentos requeridos que aún no están completos
    let requiredDocs = doctos.filter((doc) => {
      if (doc.document === 'PASSPORT') {
        return !(this.passengerInfo?.passport?.documentNumber && doc.save);
      }
      if (doc.document === 'PASSPORT/INF') {
        return !doc.save;
      }
      return true; // Otros documentos se validan normalmente
    });

    // Verifica si hay documentos requeridos sin capturar completamente
    const forceMissing = requiredDocs.some(
      (field) => field.isRequired && (!field.status || !field.save)
    );

    const { email, phones, gender, dateOfBirth } = this;
    const { phones: phoneInfo } = this.passengerInfo ?? {};

    let emailValid = true;
    if (this.paxType === PAX_TYPE.ADULT) {
      emailValid = !!email;
    }

    const isInternational = reservation?.flightSummary?.legEntity?.trim() === 'INT';
    const hasCountryOfResidence = this.countryOfResidence?.trim() !== '';

    // Resultado final: solo si todo está completo y válido se permite el check-in
    this.checkinStatusDocuments =
      !forceMissing &&
      emailValid &&
      (phones?.length > 0 || phoneInfo?.length > 0) &&
      !!gender &&
      !!dateOfBirth &&
      (!isInternational || hasCountryOfResidence);
  }

  public getStatusBagColumn() {
    const bagsReeemedAplied = this.bagStack.find(
      (x) => x.status == StatusBag.REDEEMED_APPLIED && !x.used && x.selected
    );
    const bagsToPay = this.bagStack.find(
      (x) => x.status == StatusBag.TO_PAY && !x.used && x.selected
    );
    const bagsInclude = this.bagStack.find(
      (x) => x.status == StatusBag.INCLUDE && !x.used && x.selected
    );
    const bagsPaid = this.bagStack.find((x) => x.status == StatusBag.PAID && !x.used && x.selected);
    if (bagsToPay) {
      return StatusBag.TO_PAY;
    } else if (bagsPaid) {
      return StatusBag.PAID;
    } else if (bagsReeemedAplied) {
      return StatusBag.REDEEMED_APPLIED;
    } else if (bagsInclude) return StatusBag.INCLUDE;
    else return StatusBag.NONE;
  }

  public getStatusBagColumnPremier(isViewPremier: boolean = false) {
    const bagsReeemedAplied = this.bagStack.find(
      (x) => x.status == StatusBag.REDEEMED_APPLIED && !x.used && x.selected
    );
    const bagsToPay = this.bagStack.find(
      (x) => x.status == StatusBag.TO_PAY && !x.used && x.selected
    );
    let bagsInclude, bagsPaid;

    if (isViewPremier) {
      bagsInclude = this.bagStack.find(
        (x) =>
          x.status == StatusBag.INCLUDE &&
          !x.used &&
          x.selected &&
          x.typeBagWeight != TypeBagsWeight._32KG
      );
      bagsPaid = this.bagStack.find((x) => x.status == StatusBag.PAID && !x.used && x.selected);
    } else {
      bagsInclude = this.bagStack.find(
        (x) => x.status == StatusBag.INCLUDE && !x.used && x.selected
      );
      bagsPaid = this.bagStack.find(
        (x) =>
          x.status == StatusBag.PAID &&
          !x.used &&
          x.selected &&
          x.typeBagWeight != TypeBagsWeight._25KG
      );
    }

    if (bagsToPay && isViewPremier) {
      return StatusBag.TO_PAY;
    } else if (bagsPaid) {
      return StatusBag.PAID;
    } else if (bagsReeemedAplied && isViewPremier) {
      return StatusBag.REDEEMED_APPLIED;
    } else if (bagsInclude) return StatusBag.INCLUDE;
    else return StatusBag.NONE;
  }

  public get getStatusBagColumnCarryon() {
    const bagsToPay = this.bagOfferCarryOnStack.find((x) => x.status == StatusBag.TO_PAY);
    const bagsInclude = this.bagOfferCarryOnStack.find(
      (x) => x.status == StatusBag.INCLUDE && !x.used
    );
    const bagsPaid = this.bagOfferCarryOnStack.find((x) => x.status == StatusBag.PAID && !x.used);
    const bagsDocument = this.bagOfferCarryOnStack.find((x) => x.used);

    if (bagsToPay) {
      return StatusBag.TO_PAY;
    } else if (bagsPaid) {
      return StatusBag.PAID;
    } else if (bagsDocument) {
      return StatusBag.DOCUMENT;
    } else if (bagsInclude) return StatusBag.INCLUDE;
    else return StatusBag.NONE;
  }

  private mapSeatPassenger(seats: Array<SeatPassanger>) {
    return seats?.map((seat) => {
      const column = seat?.seatCode.charAt(seat?.seatCode.length - 1);

      return {
        ...seat,
        column,
      };
    });
  }

  //#region  Bags - Maletas

  private setAncillaries(ancillaries: any[]) {
    return ancillaries.map((x) => ({ ...x, status: x.status.toLowerCase() }));
  }

  public initializeBagOfferCarryOnStack(bags: any[]): void {
    if (!bags || !Array.isArray(bags)) {
      this.bagOfferCarryOnStack = [];
      return;
    }

    this.bagOfferCarryOnStack = bags
      .filter((bag) => bag?.applyTo?.includes(this.nameRefNumber))
      .map((bag) => {
        const currencyCopy = bag?.currency ? { ...bag.currency } : undefined;
        const currencyPerLegCopy = Array.isArray(bag?.currencyPerLeg)
          ? bag.currencyPerLeg.map((leg: any) => ({
              ...leg,
              currency: leg?.currency ? { ...leg.currency } : leg?.currency,
            }))
          : [];

        // Detectar si el bag viene PAID del backend
        const isPaid = bag.status === StatusBag.PAID || bag.status === 'paid';

        return {
          ...bag,
          id: getUniqueId(4),
          currency: currencyCopy || currencyPerLegCopy?.[0]?.currency,
          currencyPerLeg: currencyPerLegCopy,
          status: isPaid ? StatusBag.PAID : StatusBag.INCLUDE,
          selected: isPaid ? true : false,
        };
      });
  }

  public onPlusExtraWeightCarryon(add: boolean, extraBagsCarryon: BagAncillarieInt[], passenger?) {
    if (!this.bagOfferCarryOnStack || this.bagOfferCarryOnStack.length === 0) {
      return;
    }

    const sourceBag = this.bagOfferCarryOnStack[0];
    const extraBags = extraBagsCarryon?.find((x) => x.order == this.bagStackCarryon.length);

    if (add) {
      // Usar el método addCarryOnBagToPay para agregar a bagStackCarryon (como carryon-basic)
      this.addCarryOnBagToPay(TypeBagsWeight._15KG, {
        ...sourceBag,
        commercialName: extraBags?.commercialName || sourceBag.commercialName || '',
        type: extraBags?.type || '',
        currency:
          sourceBag.currency || extraBags?.currency || sourceBag.currencyPerLeg?.[0]?.currency,
        currencyPerLeg: sourceBag.currencyPerLeg || extraBags?.currencyPerLeg || [],
        order: extraBags?.order || sourceBag.order,
      });
    } else {
      // Remover de bagStackCarryon si existe
      const bagToRemove = this.bagStackCarryon?.find(
        (bag) => bag.status === StatusBag.TO_PAY && bag.rficSubcode === sourceBag.rficSubcode
      );
      if (bagToRemove) {
        const index = this.bagStackCarryon.indexOf(bagToRemove);
        this.bagStackCarryon.splice(index, 1);
      }
    }
  }

  private getStackBags(reservation?: Reservation) {
    /*  Ancillaries retorna unicamente maletas pagadas  */
    const excludedTypesAncillaries = [
      '07X',
      '0CZ',
      '0NS',
      '0D6',
      '0DC',
      '0DD',
      '0EE',
      '0FR',
      '0KG',
      '0KO',
      '0N8',
    ];
    const ancillaries = this.ancillaries?.filter(
      (x) =>
        !excludedTypesAncillaries.includes(x.code) &&
        !CODES_OVERWEIGHT.includes(x.code) &&
        x.groupCode == GROUP_CODE.BAGS &&
        x.status !== StatusBag.ON_HOLD &&
        x.nameDescription?.toLowerCase().includes('bag up to')
    );

    // Se filtran maletas duplicadas por code quedandose solamente con la primera encontrada
    const uniqueAncillaries = ancillaries.filter(
      (ancillary, index, self) =>
        index ===
        self.findIndex(
          (a) =>
            a.code === ancillary.code &&
            (reservation
              ? a.segmentCode.includes(reservation?.flightSummary?.currentSegment?.segmentCode)
              : true)
        )
    );

    for (const ancillary of uniqueAncillaries) {
      const bagWeight = ancillary.nameDescription.includes('20KG')
        ? TypeBagsWeight._20KG
        : ancillary.nameDescription.includes('25KG')
        ? TypeBagsWeight._25KG
        : TypeBagsWeight._32KG;
      const isRedemption =
        ancillary.isRedemptionTier ||
        ancillary.isRedemptionFF ||
        ancillary.isRedemptionCobrand ||
        ancillary.isRedemptionCorporate;
      const isHasSelected = !!(isRedemption || ancillary.status == StatusBag.PAID);
      const statusBag = this.getStatusBag(ancillary);

      this.bagStack.push({
        id: getUniqueId(4),
        ...ancillary,
        selected: isHasSelected ? true : false,
        typeBagWeight: bagWeight,
        paid: isRedemption ? false : true,
        status: statusBag,
        isPreLoad: false,
        used: false,
        rficSubcode: ancillary.code,
        eligibility: false,
        order: this.getOrderByNameBag(ancillary),
      });
    }

    this.orderBagStack();

    // Maletas de mano
    const ancillariesCarryon = this.ancillaries?.filter(
      (x) =>
        x.code == '07X' &&
        x.groupCode == GROUP_CODE.TRAVEL_SERVICES &&
        x.status !== StatusBag.ON_HOLD
    );
    for (const ancillary of ancillariesCarryon) {
      const bagWeight = BagsWeightCode['15KG'].includes(ancillary.rficSubcode)
        ? TypeBagsWeight._15KG
        : TypeBagsWeight._10KG;
      this.bagStackCarryon[0] = {
        id: getUniqueId(4),
        ...ancillary,
        selected: false,
        typeBagWeight: bagWeight,
        paid: true,
        status: StatusBag.PAID,
        rficSubcode: ancillary.code,
      };
    }

    const ancillariesCarryon0CZ = this.ancillaries?.filter(
      (x) => x.code == '0CZ' && x.groupCode == GROUP_CODE.BAGS && x.status !== StatusBag.ON_HOLD
    );

    for (const ancillary of ancillariesCarryon0CZ) {
      const bagWeight = TypeBagsWeight._10KG; // 0CZ siempre es 10KG
      const isRedemption =
        ancillary.isRedemptionTier ||
        ancillary.isRedemptionFF ||
        ancillary.isRedemptionCobrand ||
        ancillary.isRedemptionCorporate;
      const isHasSelected = !!(isRedemption || ancillary.status == StatusBag.PAID);
      const statusBag = this.getStatusBag(ancillary);

      this.bagStackCarryon.push({
        id: getUniqueId(4),
        ...ancillary,
        selected: isHasSelected ? true : false,
        typeBagWeight: bagWeight,
        paid: isRedemption ? false : true,
        status: statusBag,
        isPreLoad: false,
        used: false,
        rficSubcode: ancillary.code,
        eligibility: false,
      });
    }
  }

  getStatusBag(ancillary) {
    const isRedemption =
      ancillary.isRedemptionTier ||
      ancillary.isRedemptionFF ||
      ancillary.isRedemptionCobrand ||
      ancillary.isRedemptionCorporate;
    const result = isRedemption ? StatusBag.REDEEMED_APPLIED : StatusBag.PAID; //isOnHold ? StatusBag.TO_PAY : StatusBag.PAID;
    return result;
  }

  orderBagStack() {
    this.bagStack = this.bagStack.sort((a, b) => a.order - b.order);
  }

  getOrderByNameBag(bag: BagsPassangerInt) {
    const orderStr = bag.nameDescription.split(' ')[0].replace('ND', '');
    const orderNum = orderStr ? parseInt(orderStr) : 0;
    return orderNum;
  }

  public buildStackBagsBenifit() {
    const isOtherBenefit =
      this.benefits?.tierBenefits?.baggage ||
      this.benefits?.cobrandBenefits?.baggage ||
      this.benefits?.ffBenefits?.baggage;

    const isCorporateBenefit =
      !isOtherBenefit && (this.corporate as any)?.corporateBenefits?.baggage;

    const benefitBags = isOtherBenefit || isCorporateBenefit;

    const hasIncludeByCorporate =
      isCorporateBenefit &&
      this.bagStack.some((x) => x.rficSubcode === '0IA' && x.status === StatusBag.INCLUDE);
    const alreadyRedeemedBenefit = this.bagStack.find(
      (x) => x.rficSubcode === '0IA' && x.status === StatusBag.PAID
    );
    if (alreadyRedeemedBenefit) {
      alreadyRedeemedBenefit.selected = true;
    }
    if (
      benefitBags &&
      !this.hasRedeemed &&
      !this.hasRedeeme &&
      (!this.hasBagsPaid || isCorporateBenefit) &&
      !hasIncludeByCorporate &&
      !alreadyRedeemedBenefit
    ) {
      this.bagStack.push({
        id: getUniqueId(4),
        commercialName: '',
        quantity: 1, // una entrada = una pieza; un 0 rompe la emisión de ancillaries
        used: false,
        groupCode: GROUP_CODE.BAGS,
        selected: isCorporateBenefit ? true : false,
        rficSubcode: '0IA',
        typeBagWeight: TypeBagsWeight._25KG,
        paid: false,
        status: isCorporateBenefit ? StatusBag.INCLUDE : StatusBag.REDEEMED,
        eligibility: false,

        currency: undefined,
        currencyPerLeg: [],
        emdType: '',
        order: this.bagStack?.length + 1,
        owningCarrierCode: '',
        rficCode: '',
        ssrCode: '',
      });
      this.orderBagStack();
    }
  }

  public buildStackBagsInclude(bags: any[]) {
    const includeBags = this.bagStack.some((x) => x.status == StatusBag.INCLUDE);
    if (!includeBags) {
      const bagsInclude = this.buildBagsInclude(bags, this.bagOfferStack);
      this.bagStack = [...this.bagStack, ...bagsInclude];
      this.orderBagStack();
    }
  }

  public buildStackBagsCarryOnInclude(bags: any[]) {
    const includeBags = this.bagStackCarryon.some((x) => x.status == StatusBag.INCLUDE);
    if (!includeBags) {
      const bagsCarryOn = this.buildBagsInclude(bags);
      this.bagStackCarryon = [...this.bagStackCarryon, ...bagsCarryOn];
    }
  }

  //#region CI-19584 — Carry-On benefit INBURSA (frontend-only)

  /** Statuses que indican que el Carry-On ya está adquirido (no se redime de nuevo). */
  private static readonly ACQUIRED_CARRYON_STATUSES: StatusBag[] = [
    StatusBag.PAID,
    StatusBag.INCLUDE,
    StatusBag.REDEEMED,
    StatusBag.REDEEMED_APPLIED,
    StatusBag.DOCUMENT,
  ];

  /** Subcodes que ya representan un Carry-On (15kg, 10kg). */
  private static readonly CARRYON_SUBCODES = ['07X', '0CZ'];

  /** True si el pax tiene algún Carry-On adquirido (cualquier flujo). */
  public get hasCarryonAcquired(): boolean {
    const stack = this.bagStackCarryon ?? [];
    return stack.some(
      (b) => Passenger.ACQUIRED_CARRYON_STATUSES.includes(b.status as StatusBag) || b.used === true
    );
  }

  /** True si ya hay una entrada redimible (REDEEMED) en `bagStackCarryon`. */
  public get hasCarryonRedeemed(): boolean {
    const stack = this.bagStackCarryon ?? [];
    return stack.some((b) => b.status === StatusBag.REDEEMED);
  }

  /** True si hay una redención Carry-On ya aplicada. */
  public get hasCarryonRedeemedApplied(): boolean {
    const stack = this.bagStackCarryon ?? [];
    return stack.some((b) => b.status === StatusBag.REDEEMED_APPLIED);
  }

  /**
   * CI-19584 — INBURSA Carry-On redeemable.
   *
   * El pax es elegible para CANJEAR Carry-On cuando:
   *  - Tiene `cobrandCode` que mapea a INBURSA (utilidad central
   *    `isInbursaCobrand`, ver whitelist + fallback en `cobrand.ts`),
   *  - NO tiene aún ningún Carry-On adquirido (PAID / INCLUDE / REDEEMED /
   *    REDEEMED_APPLIED / DOCUMENT / used).
   *
   * **Importante (caso real SFIDBT):** la elegibilidad NO depende de
   * `cobrandBenefits.baggage` ni de `typeCobrand`. En la cuenta observada
   * 340281674 (Débito Cuenta Inbursa-Aeroméxico, cobrandCode='SFIDBT')
   * backend retorna `cobrandBenefits.baggage = false` y `typeCobrand = null`,
   * pero el beneficio Carry-On INBURSA debe activarse igual.
   *
   * La restricción `MAIN_LIGHT` se aplica en `buildStackBagsCarryonBenefit`,
   * no aquí — este getter es agnóstico a tarifa.
   *
   * No se invierte ninguna validación de checked baggage: aunque el pax tenga
   * 25kg PAID, esto sigue valiendo (la guarda solo evalúa el lado Carry-On).
   */
  public get isInbursaCarryonEligible(): boolean {
    const isInbursa = isInbursaCobrand(this.benefits?.cobrandCode);
    if (!isInbursa) return false;

    if (this.hasCarryonAcquired) return false;

    return true;
  }

  /**
   * CI-19584 — Materializa la entrada Carry-On redimible (status REDEEMED)
   * en `bagStackCarryon` cuando el pax es elegible INBURSA.
   *
   * **Guarda de tarifa:** CI-19584 aplica únicamente al flujo
   * `FARES_FAMILY.MAIN_LIGHT` en Kiosko AM. Para cualquier otra tarifa, este
   * método es un no-op aunque el pax tenga cobrandCode INBURSA. El caller
   * (`PassengerService.assignBenefitsToPassenger`) pasa la tarifa del
   * `flightSummary` de la reservación.
   *
   * Diseño:
   *  - Se construye la entrada con `rficSubcode='0CZ'` (carry-on 10KG en
   *    `GROUP_CODE.BAGS`, igual al patrón existente de `0CZ` en `getStackBags`).
   *  - No inventa subcodes nuevos: solo reutiliza '0CZ' que ya existe.
   *  - Idempotente: si ya hay una entrada REDEEMED o cualquier carry-on
   *    adquirido, no hace nada (`isInbursaCarryonEligible` lo cubre).
   *  - Evita choque con un `0CZ`/`07X` previo: la guarda anterior asegura que
   *    no haya `INCLUDE`/`PAID`/etc.; este método nunca pisa entradas reales.
   *
   * **No** toca `bagStack` (checked) — esto es la clave del requerimiento:
   * permitir redención Carry-On incluso con 25kg pagado.
   *
   * @param fareFamily valor de `reservation.flightSummary.fareFamily`. Si no
   *                   es `MAIN_LIGHT`, el método retorna sin hacer nada.
   */
  public buildStackBagsCarryonBenefit(fareFamily?: string | null): void {
    // CI-19584: solo aplica a tarifa Main Light. Si el caller no provee la
    // tarifa o es otra, no creamos la entrada Carry-On.
    if (fareFamily !== FARES_FAMILY.MAIN_LIGHT) {
      return;
    }

    if (!this.isInbursaCarryonEligible) {
      return;
    }

    // Defensivo: garantizar el array.
    if (!Array.isArray(this.bagStackCarryon)) {
      this.bagStackCarryon = [];
    }

    // Defensa anti-duplicado adicional: si por alguna razón ya hay una entrada
    // con el mismo subcode (carry-on existente), no agregamos.
    const alreadyHasCarryonEntry = this.bagStackCarryon.some((b) =>
      Passenger.CARRYON_SUBCODES.includes(b.rficSubcode)
    );
    if (alreadyHasCarryonEntry) {
      return;
    }

    // CI-19584 — Main Light usa SIEMPRE el subcode Carry-On 10KG '0CZ'.
    // El subcode '07X' (Carry-On 15KG) corresponde a subtarifas básicas
    // (MAIN/AM+/PREMIER) y NO se utiliza en este flujo Main Light.
    this.bagStackCarryon.push({
      id: getUniqueId(4),
      commercialName: '',
      quantity: 1, // una entrada = una pieza; un 0 rompe la emisión de ancillaries
      used: false,
      groupCode: GROUP_CODE.BAGS,
      selected: false,
      rficSubcode: '0CZ',
      typeBagWeight: TypeBagsWeight._10KG,
      paid: false,
      status: StatusBag.REDEEMED,
      eligibility: false,
      currency: undefined,
      currencyPerLeg: [],
      emdType: '',
      order: (this.bagStackCarryon?.length || 0) + 1,
      owningCarrierCode: '',
      rficCode: '',
      ssrCode: '',
    });
  }
  //#endregion CI-19584

  private buildBagsInclude(bags: any[], offerStack: any[] = []) {
    return bags.map((bag) => {
      const matchingOffer = offerStack.find((offer: any) => offer.rficSubcode === bag.rficSubcode);

      return {
        id: bag.id || getUniqueId(4),
        commercialName: bag.commercialName || '',
        quantity: 1, // una entrada = una pieza; un 0 rompe la emisión de ancillaries
        used: bag.used || false,
        groupCode: bag.groupCode || GROUP_CODE.BAGS,
        selected: bag.used ? false : true,
        rficSubcode: bag.rficSubcode || '08K',
        typeBagWeight: bag.typeBagWeight || TypeBagsWeight._25KG,
        paid: false,
        status: StatusBag.INCLUDE,
        eligibility: false,

        currency:
          matchingOffer?.currency || matchingOffer?.currencyPerLeg?.[0]?.currency || undefined,
        currencyPerLeg: matchingOffer?.currencyPerLeg || [],
        emdType: '',
        order: bag.order,
        owningCarrierCode: bag.owningCarrierCode || '',
        rficCode: bag.rficCode || '',
        ssrCode: bag.ssrCode || '',
      };
    });
  }

  public buildBagsUsedByRemarks(remarks: RemarksInt[]) {
    remarks.forEach((remark) => {
      const remarkText = remark.text.split(' ') || [];
      const nameRefNumber = remarkText.some((t) => t.includes(this.nameRefNumber));
      if (!nameRefNumber) return;
      //se revisa si el remark tiene algun codigo de sobrepeso
      const remarkOverWeight = remarkText.find((rem) => CODES_OVERWEIGHT.includes(rem));
      let bagForUsed;
      if (remarkOverWeight) {
        bagForUsed = this.bagStack.find((bag) => !bag.used);
      } else {
        //si no tiene codigo de sobrepeso, se busca alguna maleta incluida, pagada o redimida que no este usada
        bagForUsed = this.bagStack.find(
          (b) =>
            remarkText.includes(b.rficSubcode) &&
            (b.status == StatusBag.PAID ||
              b.status == StatusBag.INCLUDE ||
              b.status == StatusBag.REDEEMED_APPLIED) &&
            !b.used
        );
      }
      if (bagForUsed) {
        bagForUsed.used = true;
        bagForUsed.selected = false; // Al usar la maleta, se deselecciona
        remarks.splice(remarks.indexOf(remark), 1); // Se elimina el remark ya procesado
      }
    });
    return this;
  }

  public buildBagsUsedByBagsMonotile(usedBags: number) {
    let bagForUsed = this.bagStack.filter(
      (b) =>
        b.status == StatusBag.PAID ||
        b.status == StatusBag.INCLUDE ||
        b.status == StatusBag.REDEEMED_APPLIED
    );

    for (const bag of bagForUsed) {
      if (usedBags > 0) {
        bag.used = true;
        bag.selected = false;
        usedBags--;
      }
    }
    return this;
  }

  public get bags25Kg() {
    return (
      this.bagStack.filter(
        (x) => x.typeBagWeight == TypeBagsWeight._25KG && x.status != StatusBag.REDEEMED && !x.used
      )?.length || 0
    );
  }

  public get bags25KgAnd32kg() {
    return (
      this.bagStack.filter(
        (x) =>
          (x.typeBagWeight == TypeBagsWeight._25KG || x.typeBagWeight == TypeBagsWeight._32KG) &&
          !x.used &&
          (x.status !== StatusBag.REDEEMED || x.selected)
      )?.length || 0
    );
  }

  /**
   * Getter que retorna el número de maletas SELECCIONADAS de 25kg y 32kg.
   * Se utiliza para mostrar el contador correcto en la UI.
   *
   * @returns {number} Cantidad de maletas seleccionadas de 25kg o 32kg no usadas
   */
  public get selectedBags25KgAnd32kg(): number {
    return this.bagStack.filter(
      (x) =>
        (x.typeBagWeight == TypeBagsWeight._25KG || x.typeBagWeight == TypeBagsWeight._32KG) &&
        x.selected &&
        !x.used
    ).length;
  }

  /**
   * Getter que retorna el número de maletas SELECCIONADAS de 25kg solamente.
   * Se utiliza para mostrar el contador correcto cuando solo se manejan maletas de 25kg.
   *
   * @returns {number} Cantidad de maletas seleccionadas de 25kg no usadas
   */
  public get selectedBags25Kg(): number {
    return this.bagStack.filter(
      (x) => x.typeBagWeight == TypeBagsWeight._25KG && x.selected && !x.used
    ).length;
  }

  public get bagsInclude() {
    return this.bagStack.filter((x) => x.status == StatusBag.INCLUDE && !x.used);
  }

  /**
   * Getter que retorna el número de maletas incluidas (25kg y 32kg) que tiene el pasajero.
   * Excluye maletas usadas.
   * Se utiliza para calcular correctamente el order al agregar maletas adicionales.
   *
   * @returns {number} Cantidad de maletas incluidas (INCLUDE) de 25kg o 32kg no usadas
   */
  public get includedBagsCount(): number {
    return this.bagStack.filter(
      (x) =>
        (x.typeBagWeight == TypeBagsWeight._25KG || x.typeBagWeight == TypeBagsWeight._32KG) &&
        x.status === StatusBag.INCLUDE &&
        !x.used
    ).length;
  }

  public get hasBagsToPay() {
    return this.bagStack.find(
      (x) =>
        x.typeBagWeight == TypeBagsWeight._25KG &&
        x.status == StatusBag.TO_PAY &&
        x.selected &&
        !x.used
    )
      ? true
      : false;
  }

  public get bags32Kg() {
    return (
      this.bagStack.filter((x) => x.typeBagWeight == TypeBagsWeight._32KG && !x.used)?.length || 0
    );
  }

  public get hasRedeemed() {
    return this.bagStack.some((x) => x.status == StatusBag.REDEEMED_APPLIED);
  }

  public get hasRedeeme() {
    return this.bagStack.some((x) => x.status == StatusBag.REDEEMED);
  }

  public get hasBagsPaid() {
    return this.bagStack.some((x) => x.status == StatusBag.PAID);
  }

  public get hasBagsPaid25Kg() {
    return this.bagStack.some(
      (x) => x.typeBagWeight == TypeBagsWeight._25KG && x.status == StatusBag.PAID
    );
  }

  public get hasBagsUsed25kg() {
    return this.bagStack.some((x) => x.used);
  }

  public get isAllowedToRedeem() {
    return this.hasRedeeme && !this.hasBagsPaid25Kg && !this.hasBagsToPay && !this.hasBagsUsed25kg;
  }

  public getLimitBags(isDomestic: boolean) {
    const bagsUsed = Math.max(
      this.bagStack.filter((x) => x.used)?.length || 0,
      this.documentedBagsCount
    );
    let maxOrder = this.getMaxBagOfferOrder();
    if (this.hasInfant && !isDomestic) {
      maxOrder += 1;
    }
    return maxOrder - bagsUsed;
  }

  public getSeletedBags() {
    return this.bagStack.filter((x) => x.selected && !x.used);
  }

  public bagsPrePaid(bagWeight: TypeBagsWeight) {
    return this.bagStack.filter(
      (x) => x.status == StatusBag.PAID && x.typeBagWeight == bagWeight && !x.used
    );
  }

  /* public onPlus20kg(count: number) {
    const bags = this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._20KG && !x.used);

    bags.map((x, index) => { if (index < count) { x.selected = true } });

    if (count > bags.length) {
      this.addBagToPay(TypeBagsWeight._20KG);
    }
  } */

  /**
   * Obtiene el order más alto de la pila de ofertas de maletas
   * @returns El valor máximo de order o 0 si no hay elementos
   */
  public getMaxBagOfferOrder(): number {
    if (!this.bagOfferStack || this.bagOfferStack?.length === 0) {
      return 0;
    }
    return Math.max(...this.bagOfferStack.map((bag) => bag.order || 1));
  }

  /**
   * Agrega maletas de 25kg al pasajero (flujo tarifa Light).
   * Calcula el order correcto excluyendo maletas INCLUDE y REDEEMED.
   * Resuelve bug CVT20-11960 (TypeError en tarifa Light + FFN).
   *
   * @param count - Número total de maletas de 25kg que el pasajero desea tener
   * @param isDomestic - Indica si el vuelo es doméstico
   */
  public onPlus25kg(count: number, isDomestic: boolean) {
    const countBagsIncludeOthers =
      this.bagStack.filter(
        (x) => x.typeBagWeight != TypeBagsWeight._25KG && x.status == StatusBag.INCLUDE
      )?.length || 0;
    const countBagsUsed =
      this.bagStack.filter((x) => x.typeBagWeight == TypeBagsWeight._25KG && x.used)?.length || 0;
    const countBags20kg =
      this.bagStack.filter((x) => x.typeBagWeight == TypeBagsWeight._20KG)?.length || 0;
    let bags = this.bagStack.filter(
      (x) => x.typeBagWeight == TypeBagsWeight._25KG && !x.used && x.status != StatusBag.REDEEMED
    );
    const hasInclude25kg = this.bagStack.some(
      (x) => x.typeBagWeight == TypeBagsWeight._25KG && x.status == StatusBag.INCLUDE
    );

    // Marcar maletas como seleccionadas
    bags.map((x, index) => {
      if (index < count) {
        x.selected = true;
      }
    });

    // CORRECCION CI-19510: separar conteo de maletas pagadas vs incluidas (solo 25kg)
    const paidAndAdded25kg = this.bagStack.filter(
      (x) =>
        x.typeBagWeight == TypeBagsWeight._25KG &&
        !x.used &&
        x.status !== StatusBag.INCLUDE &&
        x.status !== StatusBag.REDEEMED
    ).length;

    const included25kg = this.bagStack.filter(
      (x) => x.typeBagWeight == TypeBagsWeight._25KG && x.status === StatusBag.INCLUDE && !x.used
    ).length;

    const totalBags25kgInStack = paidAndAdded25kg + included25kg;

    if (count > totalBags25kgInStack) {
      let order = totalBags25kgInStack + countBagsUsed + countBags20kg + 1;

      if (this.hasInfant && !isDomestic) {
        order -= 1;
      }

      const extraBags = this.bagOfferStack.find((x) => x.order == order);

      // VALIDACION: solo agregar si se encontro la oferta (evita TypeError CVT20-11960)
      if (extraBags) {
        this.addBagToPay(TypeBagsWeight._25KG, extraBags);
      }
    }
  }

  /**
   * Agrega maletas de 25kg o 32kg al pasajero.
   * Calcula el order correcto excluyendo maletas INCLUDE y REDEEMED.
   * Resuelve bug CI-19510 (doble click para ver precio).
   *
   * @param count - Número total de maletas que el pasajero desea tener
   * @param isDomestic - Indica si el vuelo es doméstico
   */
  public onPlus(count: number, isDomestic: boolean) {
    const countBagsUsed = this.bagStack.filter((x) => x.used)?.length || 0;
    const bags = this.bagStack.filter((x) => !x.used && x.status != StatusBag.REDEEMED);
    const hasInclude25kg = this.bagStack.some(
      (x) => x.typeBagWeight == TypeBagsWeight._25KG && x.status == StatusBag.INCLUDE
    );

    // Marcar maletas como seleccionadas
    bags.map((x, index) => {
      if (index < count) {
        x.selected = true;
      }
    });
    bags.sort((a, b) => a.order - b.order);

    // CORRECCION CI-19510: separar conteo de maletas pagadas vs incluidas
    const paidAndAddedBags = this.bagStack.filter(
      (x) =>
        (x.typeBagWeight == TypeBagsWeight._25KG || x.typeBagWeight == TypeBagsWeight._32KG) &&
        !x.used &&
        x.status !== StatusBag.INCLUDE &&
        x.status !== StatusBag.REDEEMED
    ).length;

    const totalBagsInStack = paidAndAddedBags + this.includedBagsCount;

    if (count > totalBagsInStack) {
      let order = totalBagsInStack + countBagsUsed + 1;

      if (this.hasInfant && !isDomestic) {
        order -= 1;
      }

      const extraBags = this.bagOfferStack.find((x) => x.order == order);

      // VALIDACION: solo agregar si se encontro la oferta
      if (extraBags) {
        this.addBagToPay(TypeBagsWeight._25KG, extraBags);
      }
    }
  }

  public onPlus32kg(count: number) {
    const bags = this.bagStack.filter((x) => x.typeBagWeight == TypeBagsWeight._32KG && !x.used);

    bags.map((x, index) => {
      if (index < count) {
        x.selected = true;
      }
    });

    if (count > bags.length) {
      this.addBagToPay(TypeBagsWeight._32KG);
    }
  }

  public onMinusBag(count: number, bagWeight: TypeBagsWeight) {
    // CI-19510: Contar TODAS las maletas seleccionadas (de todos los tipos)
    const totalSelectedBags = this.bagStack.filter(
      (x) =>
        (x.typeBagWeight == TypeBagsWeight._25KG || x.typeBagWeight == TypeBagsWeight._32KG) &&
        !x.used &&
        x.selected
    ).length;

    // Filtrar solo las maletas del tipo específico que se pueden remover
    const bagsOfType = this.bagStack.filter(
      (x) => x.typeBagWeight == bagWeight && !x.used && x.selected
    );
    const removableBags = bagsOfType.filter((x) => x.status === StatusBag.TO_PAY);

    // CI-19510: La condición correcta es: si el count es menor que el TOTAL de maletas seleccionadas,
    // Y hay maletas removibles DEL TIPO ESPECÍFICO, entonces remover una
    const shouldRemove = count < totalSelectedBags && removableBags.length > 0;

    if (shouldRemove) {
      // Ordenar por order descendente para remover la última agregada
      const lastBag = removableBags.sort((a, b) => b.order - a.order)[0];
      this.bagStack = this.bagStack.filter((x) => x.id != lastBag.id);
    }
  }

  public onMinusBagsType(count: number, bagWeight: TypeBagsWeight[]) {
    const bags = this.bagStack.filter(
      (x) => bagWeight.includes(x.typeBagWeight) && !x.used && x.selected
    );

    if (count < bags.length) {
      const lastBag = bags.sort((a, b) => b.order - a.order)[0];

      if (lastBag.status == StatusBag.TO_PAY) {
        this.bagStack = this.bagStack.filter((x) => x.id != lastBag.id);
      } else {
        lastBag.selected = false;
      }
    }
  }

  public availableBagsAdd(bagWeight: TypeBagsWeight, isDomestic: boolean = true) {
    const totalBags = this.bagOfferStack?.length; //asignar el valor de totalBags desde la consulta de ancillaries o desde el stack de maletas (revisar)

    if (bagWeight == TypeBagsWeight._20KG) {
      return (
        this.bagStack.filter(
          (x) => x.typeBagWeight == TypeBagsWeight._20KG && !x.used && x.selected == false
        )?.length > 0
      );
    } else if (bagWeight == TypeBagsWeight._25KG) {
      const bags25Kg =
        this.bagStack.filter((x) => x.typeBagWeight == TypeBagsWeight._25KG)?.length || 0;
      const bags20Kg =
        this.bagStack.filter((x) => x.typeBagWeight == TypeBagsWeight._20KG)?.length || 0;
      const infantBonus = this.hasInfant && !isDomestic ? 1 : 0;
      const bagsUsedInStack = this.bagStack.filter((x) => x.used)?.length || 0;
      const documentedNotInStack = Math.max(0, (this.documentedBagsCount || 0) - bagsUsedInStack);
      return totalBags + infantBonus - bags25Kg - bags20Kg - documentedNotInStack > 0;
    } else if (bagWeight == TypeBagsWeight._32KG) {
      const totalBags32kgNotSelect = this.bagStack.filter(
        (x) => x.typeBagWeight == TypeBagsWeight._32KG && !x.used
      )?.length;
      const totalBags32kgSelect = this.bagStack.filter(
        (x) => x.typeBagWeight == TypeBagsWeight._32KG && !x.used && x.selected
      )?.length;
      return totalBags32kgNotSelect - totalBags32kgSelect > 0;
    } else {
      return totalBags - this.bagStack?.length > 0;
    }
  }

  /**
   * CI-20088: Determina si la siguiente maleta disponible en el bagOfferStack tiene precio $0
   * sin corresponder a un beneficio válido (corporate, rewards, cobrand, tarifa incluida).
   * Se usa para mostrar "No disponible" e inhabilitar CTAs.
   */
  public get isNextBagUnavailable(): boolean {
    if (!this.bagOfferStack || this.bagOfferStack.length === 0) {
      return false;
    }

    const countBagsUsed = this.bagStack.filter((x) => x.used)?.length || 0;
    const paidAndAddedBags = this.bagStack.filter(
      (x) =>
        (x.typeBagWeight === TypeBagsWeight._25KG || x.typeBagWeight === TypeBagsWeight._32KG) &&
        !x.used &&
        x.status !== StatusBag.INCLUDE &&
        x.status !== StatusBag.REDEEMED
    ).length;
    const totalBagsInStack = paidAndAddedBags + this.includedBagsCount;
    const nextOrder = totalBagsInStack + countBagsUsed + 1;

    const nextOffer = this.bagOfferStack.find((x) => x.order === nextOrder);
    if (!nextOffer) {
      return false;
    }

    const currencyPerLeg = nextOffer.currencyPerLeg || [];
    const currencyFromLeg = currencyPerLeg.find(
      (leg: any) => leg?.currency?.total != null
    )?.currency;
    const currency = nextOffer.currency || currencyFromLeg || null;

    const hasValidBenefit =
      this.benefits?.tierBenefits?.baggage ||
      this.benefits?.cobrandBenefits?.baggage ||
      this.benefits?.ffBenefits?.baggage ||
      (this.corporate as any)?.corporateBenefits?.baggage;

    const hasIncludedBags = this.bagStack.some((x) => x.status === StatusBag.INCLUDE && !x.used);

    const isFirstBag = totalBagsInStack === 0;
    const benefitJustifiesZero = isFirstBag && (hasValidBenefit || hasIncludedBags);

    if (!benefitJustifiesZero && (!currency || currency.total == null || currency.total <= 0)) {
      return true;
    }

    return false;
  }

  private addBagToPay(bagWeight: TypeBagsWeight, extraBags?: any) {
    const currencyPerLeg = extraBags?.currencyPerLeg || [];
    const currencyFromLeg = currencyPerLeg.find(
      (leg: any) => leg?.currency?.total != null
    )?.currency;
    var currency = extraBags?.currency || currencyFromLeg || null;

    if (!currency || currency.total == null || currency.total <= 0) {
      console.warn(
        `[addBagToPay] Blocked: Bag ${extraBags?.commercialName} has no valid price. ` +
          `currencyPerLeg length: ${currencyPerLeg.length}, ` +
          `currency: ${JSON.stringify(currency)}`
      );
      return;
    }

    // CI-18515: Aplicar defaults inmediatamente al agregar maleta
    const rficSubcode = extraBags?.rficSubcode || '0CC';
    const ssrCode = extraBags?.ssrCode || 'ABAG';
    const emdType = extraBags?.emdType || 'A';
    const owningCarrierCode = extraBags?.owningCarrierCode || 'Y4';

    // CI-18515: Inferir type del peso de la maleta
    let type = extraBags?.type || '';
    if (!type && extraBags?.baggageWeightCollection?.[0]) {
      const weight = extraBags.baggageWeightCollection[0];
      type = `${weight.baggageMaxWeight}${weight.baggageWeightUnit}`; // e.g., "25kg"
    }

    const bag: BagsPassangerInt = {
      type: type, // CI-18515: Incluir type (importante para backend)
      commercialName: extraBags?.commercialName || '',
      currency: currency,
      currencyPerLeg: currencyPerLeg,
      emdType: emdType, // CI-18515: Con default
      groupCode: GROUP_CODE.BAGS,
      id: getUniqueId(4),
      order: extraBags?.order,
      owningCarrierCode: owningCarrierCode, // CI-18515: Con default
      paid: false,
      quantity: 1,
      rficSubcode: rficSubcode, // CI-18515: Con default
      rficCode: extraBags?.rficCode || '',
      selected: true,
      ssrCode: ssrCode, // CI-18515: Con default
      status: StatusBag.TO_PAY,
      typeBagWeight: bagWeight,
      used: false,
      vendor: extraBags?.vendor,
      segmentIndicator: extraBags?.segmentIndicator,
    };

    this.bagStack.push(bag);
  }

  public addCarryOnBagToPay(
    bagWeight: TypeBagsWeight,
    extraBags?: any,
    maxAllowed = Infinity
  ): boolean {
    const currentCarryOnCount =
      this.bagStackCarryon?.filter(
        (bag) =>
          (bag.status === StatusBag.TO_PAY ||
            bag.status === StatusBag.PAID ||
            bag.status === StatusBag.REDEEMED) &&
          !bag.used
      ).length || 0;

    if (currentCarryOnCount >= maxAllowed) {
      return false;
    }

    const currencyPerLeg = extraBags?.currencyPerLeg || [];
    const currencyFromLeg = currencyPerLeg.find(
      (leg: any) => leg?.currency?.total != null
    )?.currency;
    const currency = extraBags?.currency || currencyFromLeg || undefined;

    // CI-18515: Aplicar defaults inmediatamente al agregar carry-on
    const rficSubcode = extraBags?.rficSubcode || '0CC';
    const ssrCode = extraBags?.ssrCode || 'ABAG';
    const emdType = extraBags?.emdType || 'A';
    const owningCarrierCode = extraBags?.owningCarrierCode || 'Y4';

    const bag: BagsPassangerInt = {
      commercialName: extraBags?.commercialName || '',
      currency: currency,
      currencyPerLeg: currencyPerLeg,
      emdType: emdType, // CI-18515: Con default
      groupCode: GROUP_CODE.BAGS,
      id: getUniqueId(4),
      order: extraBags?.order,
      owningCarrierCode: owningCarrierCode, // CI-18515: Con default
      paid: false,
      quantity: 1,
      rficSubcode: rficSubcode, // CI-18515: Con default
      rficCode: extraBags?.rficCode || '',
      selected: true,
      ssrCode: ssrCode, // CI-18515: Con default
      status: StatusBag.TO_PAY,
      typeBagWeight: bagWeight,
      used: false,
      vendor: extraBags?.vendor,
      segmentIndicator: extraBags?.segmentIndicator,
    };

    if (!this.bagStackCarryon) {
      this.bagStackCarryon = [];
    }

    this.bagStackCarryon.push(bag);
    return true;
  }

  //#endregion  Bags - Maletas

  get hasBlockSSR() {
    return !!this.ssrs.map((ssr) => ssr.code).find((code) => ssrBloquers.includes(code)) || false;
  }
  get notHasVCR() {
    return !this.ticketInfo || (this.ticketInfo && this.ticketInfo?.coupons.length === 0);
  }
  contentInfant() {
    return !!this.ssrs.find((ssr) => ssr.code === 'INFT');
  }

  get hasChair() {
    return (
      !!this.ssrs
        .map((ssr) => ssr.code)
        .find((code) => ssrsChairAssistant.find((ssrChair) => ssrChair.includes(code))) || false
    );
  }

  get hasVerifyDocument() {
    const excludeVerifyDocs = [
      '!INSUFFICIENT DATA FOR ESTA - ENTER DOCS',
      '!VERIFY TRAVEL DOCUMENTS',
      '!VERIFY CANADIAN VISA OR PSGR MUST OBTAIN ETA',
      '!REQUEST DHS STATUS OR PERFORM OVERRIDE ENTRY',
    ]; // ESTA, ETA, DHS
    const hasVerifyDocument = this.requiredInfoList?.find(
      (doc) => excludeVerifyDocs.includes(doc.freeText) && doc.code !== 'DOCV'
    );
    return !!hasVerifyDocument;
  }

  public getStatusSeatPreview() {
    const seatsPending =
      this.seatsNew?.length > 0
        ? this.seatsNew.find((x) => x.status == SeatPassangerEstatus.PENDING_PAYMENT)
        : this.seats.find((x) => x.status == SeatPassangerEstatus.PENDING_PAYMENT);
    const seatsPaid =
      this.seatsNew?.length > 0
        ? this.seatsNew.find((x) => x.status == SeatPassangerEstatus.PAID)
        : this.seats.find((x) => x.status == SeatPassangerEstatus.PAID);
    const seatsAssigned =
      this.seatsNew?.length > 0
        ? this.seatsNew.find((x) => x.status == SeatPassangerEstatus.ASSIGNED)
        : this.seats.find((x) => x.status == SeatPassangerEstatus.ASSIGNED);

    if (seatsPending) {
      return SeatPassangerEstatus.PENDING_PAYMENT;
    }
    if (seatsPaid) {
      return SeatPassangerEstatus.PAID;
    }
    if (seatsAssigned) {
      return SeatPassangerEstatus.ASSIGNED;
    } else {
      return SeatPassangerEstatus.NO_ASSIGNED;
    }
  }
  //#region  End: Seats - Asientos

  get hasPassengerIds(): boolean {
    return Array.isArray(this.passengerIds) && this.passengerIds.length > 0;
  }

  get mustGoToCounterByMissingPassengerIds(): boolean {
    if (this.paxType === PAX_TYPE.INFANT) {
      return false;
    }
    const hasSeamlessId = !!this.passengerIdSkyteam;
    return !this.hasPassengerIds && !hasSeamlessId;
  }
}
